export default class SubscriptionController {
  constructor(SubscriptionService, AuthService, $window, $state) {
    this.subscriptionService = SubscriptionService;
    this.authService = AuthService;
    this.window = $window;
    this.state = $state;
  }

  $onInit() {
    this.subscriptions = [];
    this.hasProfiles = this.window.localStorage.profilesCount &&
      parseInt(this.window.localStorage.profilesCount) > 0;

    this.card = {};
    this.stripe = this.window.stripe;
    const elements = this.stripe.elements();
    const style = {
        base: {
          color: '#32325d',
          lineHeight: '24px',
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: 'antialiased',
          fontSize: '16px',
          '::placeholder': {
            color: '#000000'
          }
        },
        invalid: {
          color: '#fa755a',
          iconColor: '#fa755a'
        }
    };
    this.cardElement = elements.create('card', {style: style});
    this.cardElement.mount(document.getElementById('card-element'));
    this.cardElement.addEventListener('change', (event) => {
        let displayError = document.getElementById('card-errors');
        if (event.error) {
            displayError.textContent = event.error.message;
        } else {
            displayError.textContent = '';
        }
    });
  }
  $onDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  subscribe() {
    this.stripe.createToken(this.cardElement).then(response => {
      const {token, error} = response;
      if (error) {
        const errorElement = document.getElementById('card-errors');
        errorElement.textContent = error.message;

        return;
      }

      const clientCard = angular.extend(this.card, token);
      this.subscriptions.push(
        this.subscriptionService.subscribeCustomerViaStripe(clientCard)
        .subscribe(() => this.state.go('dashboard'))
      );
    });
  }

  logout() {
    this.subscriptions.push(
        this.authService.logout().subscribe(
            (data) => this.state.go('login'),
            (error) => { }
        )
    );
  }

}

 SubscriptionController.$inject = ['SubscriptionService', 'AuthService', '$window', '$state'];



// WEBPACK FOOTER //
// ./src/app/pages/subscription/subscription.controller.js